import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getArmada(params) {
	return client.get("api-logistic/vehicle/data", {
		params: params,
	});
}

function getDetailArmada(params) {
	return client.get("api-logistic/vehicle/detail", {
		params: {
			vehicle_id : params
		},
	});
}

function addArmada(params) {
	return client.post("api-logistic/vehicle/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function editArmada(params) {
	return client.post("api-logistic/vehicle/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusArmada(params) {
	return client.post("api-logistic/vehicle/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteArmada(params) {
	return client.post("api-logistic/vehicle/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function exportArmada(params) {
	return client.get("api-logistic/vehicle/export", {
		params: params,
	});
}

export default {
	getArmada,
	getDetailArmada,
	addArmada,
	editArmada,
	statusArmada,
	deleteArmada,
	exportArmada,
};